import { useEffect, useState } from "react";

import { Divider } from "@mui/material";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import Controls from "../../../../components/form/controls/Controls";
import {
  NotifyClearCache,
  NotifyDeployCache,
} from "../../../../components/notify/Notify";
import {
  clearCacheFLFIcon,
  deployCacheFLFIcon,
  getCacheFLFIcon,
} from "../../../../apis/FLF/icon.api";
import useCurrentUserCache from "../../../../hooks/useCurrentUserCache";
import useAuth from "../../../../hooks/useAuth";
import { currentUserHandleCache } from "../../../../utils/helper";
import { allowedDeployCache } from "../../../../constants/role";

const CreateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa tạo ${listDataCache.length} icon`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#0069A9" }}
        >
          {`${index + 1}. ${data.deviceName}`}
        </p>
      ))}
    </div>
  );
};

const UpdateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa cập nhật ${listDataCache.length} icon`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#d68102" }}
        >
          {`${index + 1}. ${data.deviceName}`}
        </p>
      ))}
    </div>
  );
};

const DeleteCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa xóa ${listDataCache.length} icon`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#fb0b12" }}
        >
          {`${index + 1}. ${data.deviceName}`}
        </p>
      ))}
    </div>
  );
};

const SortCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa sắp xếp các icon, thứ tự thực hiện`}
      </p>
      {listDataCache.map((data, index) => (
        <div
          key={index}
          style={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <span
            style={{
              padding: "10px",
              fontWeight: "bold",
              color: "#d68102",
              width: "40%",
            }}
          >
            {`${index + 1}. ${data.activeIcon.deviceName}`}
          </span>
          <SwapHorizOutlinedIcon />
          <span
            style={{
              padding: "10px",
              fontWeight: "bold",
              color: "#d68102",
              width: "40%",
            }}
          >
            {`${data.overIcon.deviceName}`}
          </span>
        </div>
      ))}
    </div>
  );
};

const objectActionCache = {
  Create: CreateCache,
  Update: UpdateCache,
  Delete: DeleteCache,
  Sort: SortCache,
};

const RenderCache = ({
  listDataCache,
  actionCache,
  localUser,
  currentUserCache,
}) => {
  if (actionCache) {
    return objectActionCache[actionCache]({
      listDataCache,
      localUser,
      currentUserCache,
    });
  }
  return null;
};

const ShowCacheFLFIcon = () => {
  const [listDataCache, setListDataCache] = useState([]);
  const [modelCache, setModelCache] = useState();
  const [actionCache, setActionCache] = useState();

  const { currentUserCache } = useCurrentUserCache();

  const { auth } = useAuth();

  useEffect(() => {
    getCacheFLFIcon((result) => {
      setListDataCache(result.data);
      setModelCache(result.model);
      setActionCache(result.action);
    });
  }, []);

  const handleDeployData = () => {
    NotifyDeployCache(
      "warning",
      "Deploy Data ?",
      "<h5> Tất cả dữ liệu mới sẽ được lưu </h5>",
      (result) => {
        if (result.isConfirmed) {
          deployCacheFLFIcon((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  const handleClearData = () => {
    NotifyClearCache(
      "warning",
      "Clear Cache ?",
      "<h5> Tất cả dữ liệu mới sẽ được hủy bỏ </h5>",
      (result) => {
        if (result.isConfirmed) {
          clearCacheFLFIcon((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  return (
    <>
      <RenderCache
        listDataCache={listDataCache}
        modelCache={modelCache}
        actionCache={actionCache}
        localUser={auth}
        currentUserCache={currentUserCache}
      />
      <Divider sx={{ width: "100%" }} />
      {allowedDeployCache(
        currentUserCache?.email,
        auth?.email,
        auth?.permissions
      ) ? (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Controls.Button
            sx={{
              width: "150px",
              marginTop: "10px",
            }}
            color="secondary"
            type="button"
            text="Clear Cache"
            onClick={handleClearData}
          />
          <Controls.Button
            sx={{ width: "150px", marginTop: "10px", marginLeft: "10px" }}
            type="button"
            text="Deploy Data"
            onClick={handleDeployData}
          />
        </div>
      ) : null}
    </>
  );
};

export default ShowCacheFLFIcon;
